import clsx from 'clsx'

import { Card } from '@/shared/ui/Card'

import { Skeleton } from './Skeleton'

export type ResourceListCardSkeletonProps = {
  className?: string
  /** Simula card em destaque (borda brand), ex.: carrossel de top likes. */
  highlight?: boolean
  /** Exibe linha extra de descrição — padrão dos cards de parceiro. */
  withDescription?: boolean
  /** Exibe pill de categoria/badge acima do título. */
  withBadge?: boolean
  /** Exibe coluna de rail à direita (reação/CTA). */
  withRail?: boolean
  /** Classes da thumbnail — padrão quadrado (§7 L8); parceiros usam 4:3. */
  thumbClassName?: string
  /** Faixa de destaque no topo (top curtidas / missão em destaque). */
  withFeaturedStrip?: boolean
  /** Largura do rail — parceiros/programação usam 70px. */
  railClassName?: string
}

/**
 * Placeholder do card de listagem de recurso (MASTER §7 L8).
 * Base canônica para parceiros, missões, jornadas, quizzes e prêmios.
 */
export const ResourceListCardSkeleton = ({
  className,
  highlight = false,
  withDescription = true,
  withBadge = true,
  withRail = true,
  withFeaturedStrip = false,
  thumbClassName = 'aspect-square w-20 shrink-0 self-start',
  railClassName = 'w-[var(--rail-w-sm)]'
}: ResourceListCardSkeletonProps) => (
  <Card
    flush={withFeaturedStrip}
    className={clsx(
      'card-gamification shadow-sm',
      highlight && 'border-2 border-[var(--color-featured-partner-border)] bg-brand-light/10',
      className
    )}
  >
    {withFeaturedStrip && (
      <Skeleton variant="pill" className="h-7 w-full rounded-none" />
    )}

    <Card.Body>
      <div className="flex items-stretch gap-2 sm:gap-3">
        <Skeleton variant="thumb" className={thumbClassName} />

        <div className="flex min-w-0 flex-1 flex-col justify-center gap-1.5">
          {withBadge && <Skeleton variant="pill" className="h-4 w-20" />}
          <Skeleton className="h-4 w-[88%]" />
          <Skeleton className="h-4 w-[62%]" />
          {withDescription && (
            <>
              <Skeleton className="h-3 w-full" />
              <Skeleton className="h-3 w-[78%]" />
            </>
          )}
        </div>

        {withRail && (
          <div
            className={clsx(
              'flex min-h-20 shrink-0 flex-col items-end justify-center gap-2',
              railClassName
            )}
          >
            <Skeleton variant="pill" className="h-7 w-full rounded-lg" />
          </div>
        )}
      </div>
    </Card.Body>
  </Card>
)
